import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductDetail.css';

const products = {
    'gfrp-rebar': {
        id: 'gfrp-rebar',
        name: 'GFRP Rebar',
        image: '/straight.webp',
        tagline: 'Industry-leading high-strength composite reinforcing bars engineered for superior performance',
        description: 'The ultimate replacement for epoxy-coated or galvanized steel, delivering unmatched durability and longevity in concrete structures.',
        stats: [
            { value: '>1000 MPa', label: 'Tensile Strength' },
            { value: '75%', label: 'Lighter than Steel' },
            { value: '100+ Years', label: 'Service Life' }
        ],
        variants: {
            mostOrdered: [
                { diameter: '6mm', applications: 'Slabs, foundations, precast elements' },
                { diameter: '8mm', applications: 'Beams, columns, structural walls' },
                { diameter: '10mm', applications: 'Bridges, marine structures, heavy-duty applications' },
                { diameter: '12mm', applications: 'High-rise buildings, infrastructure projects' }
            ],
            range: '5mm - 20mm',
            availableDiameters: ['5mm', '6mm', '8mm', '10mm', '12mm', '14mm', '16mm', '18mm', '20mm']
        },
        specs: [
            'Diameter Range: 5mm - 20mm (Standard)',
            'Tensile Strength: >1000 MPa (Industry-leading performance)',
            'Elastic Modulus: >50 GPa (Superior structural integrity)',
            'Lengths: Up to 12m standard lengths or custom coils',
            'Weight: 75% lighter than equivalent steel reinforcement',
            'Corrosion Resistance: 100% - Zero maintenance required',
            'Thermal Expansion: Similar to concrete (optimal compatibility)',
            'Electrical Conductivity: Non-conductive (ideal for sensitive applications)',
            'Bond Strength: Superior adhesion with concrete matrix',
            'Service Life: 100+ years in aggressive environments'
        ],
        fullDescription: 'BLITZ GFRP (Glass Fiber Reinforced Polymer) rebars represent the pinnacle of modern composite reinforcement technology, engineered to deliver exceptional performance across the most demanding infrastructure applications. Our state-of-the-art manufacturing facility utilizes advanced pultrusion processes to produce rebars with consistent fiber distribution, ensuring uniform strength properties throughout the entire length. These premium composite rebars offer unparalleled corrosion resistance, making them the preferred choice for structures exposed to harsh environments including marine zones, coastal infrastructure, chemical processing facilities, and wastewater treatment plants.',
        keyFeatures: [
            'Third-party tested and certified to international standards',
            'Custom diameters and lengths available for specialized projects',
            'Comprehensive technical support and engineering consultation',
            'Proven track record in major infrastructure projects across India',
            'Sustainable manufacturing with 43% lower carbon footprint',
            'Zero maintenance requirements throughout service life',
            'Compatible with all standard concrete mixing and placement methods',
            'Superior electromagnetic neutrality for sensitive installations'
        ],
        applications: [
            'Marine and coastal structures (ports, jetties, seawalls)',
            'Bridge decks and infrastructure',
            'Water and wastewater treatment facilities',
            'Chemical and industrial processing plants',
            'High-rise buildings and commercial structures',
            'Transportation infrastructure (highways, railways)',
            'Precast concrete elements',
            'Underground structures and tunnels'
        ]
    },
    'gfrp-mesh': {
        id: 'gfrp-mesh',
        name: 'GFRP Mesh',
        image: '/curvedBars.webp',
        tagline: 'Precision-engineered prefabricated mesh panels for optimal slab reinforcement',
        description: 'Dramatically reduce on-site labor requirements and accelerate construction timelines while ensuring consistent reinforcement coverage.',
        stats: [
            { value: '40-50%', label: 'Faster Installation' },
            { value: '60-70%', label: 'Lighter than Steel' },
            { value: 'Custom', label: 'Grid Sizes' }
        ],
        variants: {
            mostOrdered: [
                { diameter: '6mm', applications: 'Residential slabs, light commercial floors' },
                { diameter: '8mm', applications: 'Commercial slabs, parking structures' },
                { diameter: '10mm', applications: 'Industrial floors, heavy-duty applications' },
                { diameter: '12mm', applications: 'High-load industrial applications, bridge decks' }
            ],
            range: '5mm - 20mm',
            availableDiameters: ['5mm', '6mm', '8mm', '10mm', '12mm', '14mm', '16mm', '18mm', '20mm'],
            gridSizes: 'Customizable from 50mm x 50mm to 300mm x 300mm'
        },
        specs: [
            'Wire Diameter: 5mm - 20mm (Standard range)',
            'Tensile Strength: >1000 MPa per wire',
            'Weight: 60-70% lighter than equivalent steel mesh',
            'Corrosion Resistance: 100% - Zero maintenance required',
            'Installation Time: 40-50% faster than traditional reinforcement',
            'Non-conductive: Ideal for electrical isolation applications',
            'Bond Performance: Superior adhesion with concrete',
            'Custom Shapes: Available for complex geometries',
            'Standard Panel Size: 2.4m x 4.8m',
            'Grid Spacing: 50mm to 300mm (customizable)'
        ],
        fullDescription: 'BLITZ GFRP mesh panels represent a revolutionary approach to concrete slab reinforcement, combining prefabrication efficiency with the superior properties of glass fiber reinforced polymers. Our advanced manufacturing facility produces precision-engineered mesh panels using automated welding and quality control systems, ensuring consistent wire spacing, perfect alignment, and uniform strength distribution across every panel. These lightweight, corrosion-free mesh panels dramatically reduce on-site labor requirements—typically cutting installation time by 40-50% compared to traditional reinforcement methods.',
        keyFeatures: [
            'Automated manufacturing with precision quality control',
            'Standard and custom panel sizes available',
            'Significantly faster installation than traditional methods',
            'Consistent wire spacing and alignment guaranteed',
            'Compatible with all standard concrete placement methods',
            'Technical drawings and engineering support included',
            'Proven performance in major commercial and industrial projects',
            'Sustainable solution with reduced environmental impact'
        ],
        applications: [
            'Residential and commercial floor slabs',
            'Parking structures and ramps',
            'Industrial floors and warehouses',
            'Bridge deck overlays',
            'Precast concrete panels',
            'Tilt-up construction',
            'Medical facilities requiring non-conductive reinforcement',
            'Data centers and sensitive electronic installations'
        ]
    },
    'bent-bars-stirrups': {
        id: 'bent-bars-stirrups',
        name: 'Bent Bars & Stirrups',
        image: '/bentBars.webp',
        tagline: 'Precision-engineered custom bent shapes manufactured to exact specifications',
        description: 'Advanced controlled precision bending technology ensures perfect dimensional accuracy and eliminates on-site fabrication requirements.',
        stats: [
            { value: '±2mm', label: 'Tolerance' },
            { value: '>800 MPa', label: 'Shear Strength' },
            { value: '100%', label: 'Quality Inspected' }
        ],
        variants: {
            mostOrdered: [
                { diameter: '6mm', shapes: 'Stirrups, hooks, U-bars', applications: 'Beam stirrups, slab reinforcement' },
                { diameter: '8mm', shapes: 'Stirrups, closed loops, L-bars', applications: 'Column ties, beam reinforcement' },
                { diameter: '10mm', shapes: 'Complex stirrups, multi-bend shapes', applications: 'Heavy beams, structural frames' },
                { diameter: '12mm', shapes: 'Large stirrups, custom geometries', applications: 'High-rise structures, bridges' }
            ],
            range: '5mm - 20mm',
            availableDiameters: ['5mm', '6mm', '8mm', '10mm', '12mm', '14mm', '16mm', '18mm', '20mm'],
            bendingCapabilities: 'All standard shapes: 90°, 135°, 180° bends, custom angles available'
        },
        specs: [
            'Diameter Range: 5mm - 20mm (Standard), up to 32mm (Custom)',
            'Bending Angles: Standard 90°, 135°, 180° + custom angles',
            'Dimensional Tolerance: ±2mm (Industry-leading precision)',
            'Shear Strength: >800 MPa (Superior structural performance)',
            'Bend Radius: Minimum 4x diameter (Optimal for structural integrity)',
            'Custom Shapes: Complex geometries and multi-bend configurations',
            'Quality Control: 100% dimensional inspection before shipment',
            'Engineering Support: Design review and optimization available',
            'Delivery: Ready-to-install components, no on-site fabrication',
            'Compatibility: Works seamlessly with straight GFRP rebars'
        ],
        fullDescription: 'BLITZ custom bent bars and stirrups represent the pinnacle of precision manufacturing in composite reinforcement, engineered to your exact structural design specifications using state-of-the-art controlled precision bending technology. Our advanced manufacturing facility features cutting-edge equipment capable of producing complex shapes, hooks, stirrups, and multi-bend configurations with dimensional tolerances of ±2mm—ensuring perfect fit and eliminating costly on-site modifications.',
        keyFeatures: [
            'Controlled precision bending technology',
            'Dimensional accuracy within ±2mm tolerance',
            'Design review and engineering consultation included',
            'Complex multi-bend configurations available',
            '100% quality inspection before shipment',
            'Ready-to-install, no on-site fabrication required',
            'Compatible with all standard GFRP rebar diameters',
            'Proven performance in major infrastructure projects'
        ],
        applications: [
            'Beam and column reinforcement (stirrups and ties)',
            'Shear reinforcement in structural elements',
            'Confinement reinforcement for seismic applications',
            'Precast concrete element reinforcement',
            'Complex structural geometries',
            'Bridge and infrastructure projects',
            'High-rise building construction',
            'Industrial and commercial structures'
        ]
    }
};

function ProductDetail() {
    const { productId } = useParams();
    const navigate = useNavigate();
    const product = products[productId];
    const [selectedVariant, setSelectedVariant] = React.useState(0);

    if (!product) {
        return (
            <div className='product-detail'>
                <Navbar />
                <div className="product-not-found">
                    <div className="product-not-found-icon">🏗️</div>
                    <h2>Product Not Found</h2>
                    <p>The product you're looking for doesn't exist or may have been moved.</p>
                    <button className="product-not-found-button" onClick={() => navigate('/about')}>
                        Browse All Products
                    </button>
                </div>
                <Footer />
            </div>
        );
    }

    const handleContactClick = () => {
        navigate('/contact');
    };

    const mostOrderedVariants = product.variants?.mostOrdered || [];
    const currentVariant = mostOrderedVariants[selectedVariant];

    return (
        <div className='product-detail'>
            <Navbar />

            {/* Product Hero Section */}
            <div className="product-hero-section">
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: 'url(/headerBg.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.06,
                        zIndex: 1
                    }}
                />
                <div className="product-hero-container">
                    <div className="product-hero-breadcrumb">
                        <a href="/about">Products</a>
                        <span className="product-hero-breadcrumb-separator">→</span>
                        <span>{product.name}</span>
                    </div>

                    <div className="product-hero-content">
                        <div className="product-hero-text">
                            <div className="product-hero-badge">
                                ⭐ Premium GFRP Solution
                            </div>
                            <h1 className="product-hero-title">{product.name}</h1>
                            <p className="product-hero-tagline">{product.tagline}</p>
                            <div className="product-hero-stats">
                                {product.stats.map((stat, index) => (
                                    <div key={index} className="product-hero-stat">
                                        <div className="product-hero-stat-value">{stat.value}</div>
                                        <div className="product-hero-stat-label">{stat.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="product-hero-image-container">
                            <div className="product-hero-image-wrapper">
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    className="product-hero-image"
                                />
                                {currentVariant && (
                                    <div className="product-variant-floating-badge">
                                        {currentVariant.diameter}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product Content Section */}
            <div className="product-content-section">
                <div className="product-content-grid">
                    {/* Description */}
                    <div className="product-description-section">
                        <div>
                            <h2 className="product-section-title">Product Overview</h2>
                            <p className="product-short-description">{product.description}</p>
                            <p className="product-full-description">{product.fullDescription}</p>
                        </div>
                    </div>

                    {/* Technical Specifications */}
                    <div className="product-specs-section">
                        <h2 className="product-section-title">Technical Specifications</h2>
                        <ul className="product-specs-list">
                            {product.specs.map((spec, index) => (
                                <li key={index} className="product-spec-item">
                                    {spec}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Variants Section */}
                    {product.variants && (
                        <div className="product-variants-section">
                            <div className="product-variants-header">
                                <div className="product-variants-title-group">
                                    <h3 className="product-variants-title">Available Variants</h3>
                                    <p className="product-variants-subtitle">
                                        Most Ordered: {product.variants.mostOrdered.map(v => v.diameter).join(', ')}
                                    </p>
                                </div>
                                <div className="product-variants-range-badge">
                                    Range: {product.variants.range}
                                </div>
                            </div>
                            <div className="product-variants-grid">
                                {product.variants.mostOrdered.map((variant, index) => (
                                    <div
                                        key={index}
                                        className={`product-variant-card ${selectedVariant === index ? 'active' : ''}`}
                                        onClick={() => setSelectedVariant(index)}
                                    >
                                        <div className="variant-diameter">{variant.diameter}</div>
                                        {variant.weight && (
                                            <div className="variant-weight">{variant.weight}</div>
                                        )}
                                        {variant.grid && (
                                            <div className="variant-grid">{variant.grid}</div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {currentVariant && (
                                <div className="variant-details">
                                    <h4 className="variant-details-title">
                                        {currentVariant.diameter} Specifications
                                    </h4>
                                    <p className="variant-application">
                                        <strong>Applications:</strong> {currentVariant.applications}
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Key Features Section */}
            {product.keyFeatures && (
                <div className="product-features-section">
                    <div className="product-features-container">
                        <h2 className="product-section-title">Key Features & Benefits</h2>
                        <div className="features-grid">
                            {product.keyFeatures.map((feature, index) => (
                                <div key={index} className="feature-item">
                                    <div className="feature-icon">✓</div>
                                    <p className="feature-text">{feature}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Applications Section */}
            {product.applications && (
                <div className="product-applications-section">
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: 'url(/headerBg.jpg)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            opacity: 0.05,
                            zIndex: 1
                        }}
                    />
                    <div className="product-applications-container">
                        <div className="product-applications-header">
                            <h2 className="product-applications-title">Ideal Applications</h2>
                            <p className="product-applications-subtitle">
                                Trusted across critical infrastructure projects nationwide
                            </p>
                        </div>
                        <div className="applications-grid">
                            {product.applications.map((application, index) => (
                                <div key={index} className="application-item">
                                    <div className="application-icon">🏗️</div>
                                    <p className="application-text">{application}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* CTA Section */}
            <div className="product-cta-section">
                <div className="product-cta-container">
                    <div className="product-cta-content">
                        <h3 className="product-cta-title">Ready to Transform Your Project?</h3>
                        <p className="product-cta-description">
                            Contact us today for customized quotations, technical specifications, and expert consultation.
                            Our engineering team is ready to help you achieve superior structural performance.
                        </p>
                        <div className="product-cta-buttons">
                            <button className="product-cta-button-primary" onClick={handleContactClick}>
                                Get Custom Quote
                            </button>
                            <button className="product-cta-button-secondary" onClick={() => window.location.href = 'tel:+919654622026'}>
                                Call: +91 96546 22026
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default ProductDetail;